import { React, useState } from 'react'; 
import Modal from 'react-bootstrap/Modal';

const MapModal = () => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>

            <button className="link-button mapLink" onClick={handleShow}  ><p className="contactUsPostcode">B91 2AA</p></button>

            <Modal show={show} onHide={handleClose} size='lg' >
                <Modal.Header closeButton>
                    <Modal.Title>Find us</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mapModalBody'>
                <iframe title='embededMap' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2433.5896013326324!2d-1.7839377841964765!3d52.41411377979431!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4870b7a85f700ae7%3A0xba1212067e21dd6!2sCore%20Gaming%20Ltd!5e0!3m2!1sen!2suk!4v1686325380295!5m2!1sen!2suk" className='mapIframe' /*width="460" height="350"*/  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                </Modal.Body>

            </Modal>
        </>
    )
}

export default MapModal